import Order from './Order'

export default class ShopifyOrder extends Order {
  static fields () {
    return {
      platform: this.string('Shopify'),
      isPrime: this.boolean(false)
    }
  }

  static getSheetName () {
    return 'Shipping info'
  }

  static fileType = 'xlsx';

  static getFileHeader () {
    return [
      'Order ID',
      'SKU ID(optional)',
      'Quantity(optional)',
      'Tracking ID',
      'Shipping service'
    ]
  }

  getFileRows () {
    return this.shipments.map(shipment => [
      this.orderId,
      shipment.orderItemId,
      shipment.quantity,
      shipment.trackingNumber,
      shipment.carrierName || shipment.carrierCode
    ])
  }
}



// WEBPACK FOOTER //
// ./src/orm/models/Order/ShopifyOrder.js